import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
let PitFilterTreeNodeType = class PitFilterTreeNodeType {
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get ord() {
        return this._ord;
    }
    set ord(value) {
        this._ord = value;
    }
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "id", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFilterTreeNodeType.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ name: "ord", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFilterTreeNodeType.prototype, "_ord", void 0);
tslib_1.__decorate([
    jsonMember({ name: "name", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitFilterTreeNodeType.prototype, "_name", void 0);
PitFilterTreeNodeType = tslib_1.__decorate([
    jsonObject
], PitFilterTreeNodeType);
export { PitFilterTreeNodeType };
